import { render, staticRenderFns } from "./FBarDate.vue?vue&type=template&id=71c6e2a6&scoped=true&"
import script from "./FBarDate.vue?vue&type=script&lang=js&"
export * from "./FBarDate.vue?vue&type=script&lang=js&"
import style0 from "./FBarDate.vue?vue&type=style&index=0&id=71c6e2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c6e2a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/souzaramon/repos/personal/fluid/pwa-fluid/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
